import { appInitialized, initializeAnalytics } from '@src/state/app/actions'
import { cheggAuthLoaded, setParsedJwt } from '@src/state/auth/actions'
import { RootState } from '@src/state/types'
import { createLogic } from 'redux-logic'
import { getType } from 'typesafe-actions'

export const appInitializationLogic = createLogic<RootState>({
  type: [getType(setParsedJwt), getType(cheggAuthLoaded)],
  validate({ getState, action }, allow, reject) {
    const state = getState()
    if (
      (state.auth.jwt || action.type === getType(setParsedJwt)) &&
      !state.app.initialized
    ) {
      allow(action)
    }
    reject(action)
  },
  process({}, dispatch, done) {
    dispatch(appInitialized())
    dispatch(initializeAnalytics())

    done()
  },
})

export default [appInitializationLogic]



// WEBPACK FOOTER //
// ./src/state/app/logic.ts